import ApiHelper from "./ApiHelper";

class AuthService {
  static async SignIn(body) {
    return ApiHelper.postAnonymous("/admin/login", body);
  }
  static async resetUserPassword(body) {
    return ApiHelper.postAnonymous("/admin/password/reset", body);
  }
  static async verifyOtp(data) {
    return ApiHelper.postAnonymous("/admin/verify-otp", data);
  }
  static async resendOtp(data) {
    return ApiHelper.postAnonymous("/admin/resend-otp", data);
  }
}
export default AuthService;
